module.exports = __webpack_public_path__ + "media/images/front/banner_cc_wide-969d6bc96fe0a1b613460521bdbd3aed.jpg";